import moment from 'moment';
import ClientStorage from '@fec/frontend/foundation/client/storage';
import { STORAGE_KEY } from '@fec/frontend/elements/text/teaser-info/teaser-info-updater';

/*
 * Encapsulates an Algolia query response.
 * - getItems returns fetched items transormed to a teaser format (including urls etc)
 * - getCount returns max hits
 * - hasMoreResults shows if there are results left.
 */

export default class AlgoliaResponse {
  constructor(algoliaResponse, trans, isWebview) {
    this.algoliaResponse = algoliaResponse;
    this.trans = trans;
    this.isWebview = isWebview;
    this.seenItems = ClientStorage.getItemJsonParsed(STORAGE_KEY, []);
  }

  getCount() {
    return this.algoliaResponse.nbHits;
  }

  getCurrentPage() {
    return this.algoliaResponse.page;
  }

  getItems() {
    return this.algoliaResponse.hits.map((searchItem) =>
      this.mapAlgoliaResultToTeaser(searchItem, this.isWebview),
    );
  }

  hasMoreResults() {
    return !(
      this.algoliaResponse &&
      this.algoliaResponse.nbPages - 1 <= this.algoliaResponse.page
    );
  }

  // internal mapping functions
  mapAlgoliaResultToTeaser(searchItem) {
    const mediaIcon =
      searchItem.mediaIcon && searchItem.mediaIcon.icon
        ? searchItem.mediaIcon.icon
        : '';

    return {
      kicker: this.getField('kicker', searchItem),
      title: this.getField('headline', searchItem),
      description: this.getField('description', searchItem),
      link: this.isWebview ? searchItem.urls.webview : searchItem.urls.web,
      image: searchItem.teaserImage ? searchItem.teaserImage : '',
      urn: searchItem.urn,
      imageDescription: '',
      date: new Date(searchItem.publishedDate * 1000).toISOString(),
      mediaIcon: mediaIcon,
      isVisited:
        this.seenItems.filter((item) => item.urn === searchItem.urn).length > 0,
      visitedText: this.trans.visited,
      updateTime: this.trans.dateAndTime.replace(
        '%date_time%',
        moment(searchItem.publishedDate * 1000).format('DD.MM.YYYY, k:mm'),
      ),
      mediaDescription: this.trans.mediacontent.replace(
        '%media%',
        mediaIcon == 'image' ? this.trans.imgGallery : mediaIcon,
      ),
    };
  }

  getField(field, searchItem) {
    if (field === 'description') {
      return this.getDescription(searchItem);
    }

    return field in searchItem ? searchItem[field] : '';
  }

  getDescription(searchItem) {
    let selectedSnippets = [];
    let snippets = [searchItem._snippetResult['lead']];
    let numOfSnippets = 2;

    // flatten snippet of shortLead and paragraphs
    if (searchItem._snippetResult['paragraphs']) {
      snippets = snippets.concat(searchItem._snippetResult['paragraphs']);
    }

    // search "full"
    snippets.forEach((snippet) => {
      if (snippet['matchLevel'] == 'full') {
        if (selectedSnippets.length >= numOfSnippets) {
          return;
        }
        selectedSnippets.push(snippet['value']);
      }
    });

    // if not yet n found, take "partials"
    if (selectedSnippets.length < numOfSnippets) {
      snippets.forEach((snippet) => {
        if (snippet['matchLevel'] == 'partial') {
          if (selectedSnippets.length >= numOfSnippets) {
            return;
          }
          selectedSnippets.push(snippet['value']);
        }
      });
    }

    return selectedSnippets.length > 0
      ? this.sanitizeSnippets(selectedSnippets).join(' ').replace('… …', '…')
      : searchItem['shortLead'];
  }

  /**
   * fixes an algolia bug: remove highlight around single .
   * @param snippets
   */
  sanitizeSnippets(snippets) {
    return snippets.map((snippet) => {
      return snippet.replace('<em>.</em>', '.');
    });
  }
}
